module.exports = __webpack_public_path__ + "static/media/add_icon.e01b7d2b.svg";